import './App.css';
import { Routes, Route } from 'react-router-dom';
import SeoHead from './components/SeoHead';
import Home from './pages/Home';
import Sale from './pages/Sale';
import SaleProject from './pages/SaleProject';
import Rent from './pages/Rent';
import RentProject from './pages/RentProject';
import About from './pages/About';
import Contact from './pages/Contact';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: [
      'Fauna One',
      'serif'
    ].join(','),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <SeoHead />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/sale' element={<Sale />} />
        <Route path='/saleproject/:id' element={<SaleProject />} />
        <Route path='/projects' element={<Rent />} />
        <Route path='/rentproject/:id' element={<RentProject />} />
        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
